import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ContentProvider } from "@/context/ContentContext";
import { ProtectedRoute, AdminRoute } from "@/components/RouteGuards";
import Navbar from "@/components/Navbar";
import Marquee from "@/components/Marquee";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Organy from "@/pages/Organy";
import Status from "@/pages/Status";
import Szkolenia from "@/pages/Szkolenia";
import SzkolenieDetail from "@/pages/SzkolenieDetail";
import AnnouncementDetail from "@/pages/AnnouncementDetail";
import Kontakt from "@/pages/Kontakt";
import Forum from "@/pages/Forum";
import ForumTopic from "@/pages/ForumTopic";
import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import Admin from "@/pages/admin/Admin";
import NotFound from "@/pages/NotFound";

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <Marquee />
      <main className="min-h-[70vh]">{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
              <Route path="/organy" element={<PublicLayout><Organy /></PublicLayout>} />
              <Route path="/status" element={<PublicLayout><Status /></PublicLayout>} />
              <Route path="/szkolenia" element={<PublicLayout><Szkolenia /></PublicLayout>} />
              <Route path="/szkolenia/:id" element={<PublicLayout><SzkolenieDetail /></PublicLayout>} />
              <Route path="/aktualnosci/:id" element={<PublicLayout><AnnouncementDetail /></PublicLayout>} />
              <Route path="/kontakt" element={<PublicLayout><Kontakt /></PublicLayout>} />
              <Route path="/login" element={<PublicLayout><Login /></PublicLayout>} />
              <Route path="/rejestracja" element={<PublicLayout><Register /></PublicLayout>} />
              <Route path="/forgot-password" element={<PublicLayout><ForgotPassword /></PublicLayout>} />
              <Route path="/reset-password" element={<PublicLayout><ResetPassword /></PublicLayout>} />
              <Route path="/forum" element={<PublicLayout><ProtectedRoute><Forum /></ProtectedRoute></PublicLayout>} />
              <Route path="/forum/:id" element={<PublicLayout><ProtectedRoute><ForumTopic /></ProtectedRoute></PublicLayout>} />
              <Route path="/_ztkig_admin" element={<AdminRoute><Admin /></AdminRoute>} />
              <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
